module.exports = __webpack_public_path__ + "media/videos/mariam-singing-subtitles.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/media/videos/mariam-singing-subtitles.mp4
// module id = 129
// module chunks = 0